import IndividualPerson from './IndividualPerson';
import LegalEntity from './LegalEntity';
import { entityTypes } from '../../static/types/objectType';
import { initialManagerState } from '../../static/types/objectInitialState';
import { initialIndividualState } from '../../static/initialState/commonInitialState/individualInitialState';
import { initialLegalEntityState } from '../../static/initialState/commonInitialState/legalEntityInitalState';
import { ManagerType } from '../../static/types/commonTypes/managerType';
import useAppContext from '../../hooks/useAppContext';
import { AppContextType } from '../../context/AppContext';

type ManagerListProps = {
    checked: boolean,
    societyTypeOptions: string[],
    managers: ManagerType[],
    addButtonText: string,
    removeButtonText: string,
    draftFieldName?: string,
    labelItem?: string,
    setManagers: (managers: ManagerType[]) => void
    setManagersValidity: (isValid: boolean) => void
}

export default function ManagerList({
    checked,
    societyTypeOptions,
    managers,
    labelItem,
    setManagers,
    addButtonText,
    removeButtonText,
    setManagersValidity,
    draftFieldName
}: ManagerListProps) {

    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    let listValidity: boolean[] = [false]

    const addManager = () => {
        setManagers([
            ...managers,
            initialManagerState
        ]);
        listValidity.push(false)
        
        let draft = parseDraft()
        const tempDraft = { ...draft, [ draftFieldName || 'managers' ]: [
            ...managers,
            initialManagerState
        ]}
        setDraftFormData( stringifyDraft( tempDraft ))
    };

    const removeLastManager = () => {
        if (managers.length > 1) {
            setManagers(managers.slice(0, -1));
            let draft = parseDraft()
            const tempDraft = { ...draft, [ draftFieldName || 'managers' ]: managers.slice(0, -1)}
            setDraftFormData( stringifyDraft( tempDraft ))
        }
        if (listValidity.length > 1) {
            listValidity.slice(0, -1)
        }
    };

    const updateManager = (index: number, updatedManager: ManagerType) => {
        const newManagers = [...managers];
        newManagers[index] = updatedManager;
        setManagers(newManagers);
        let draft = parseDraft()
        const tempDraft = { ...draft, [ draftFieldName || 'managers' ]: newManagers }
        setDraftFormData( stringifyDraft( tempDraft ))
    };

    const toggleManagerType = (person: "Personne physique" | "Personne morale", index: number) => {

        const newManager: ManagerType = person === "Personne physique"
            ? {
                person: "Personne physique",
                personDetails: initialIndividualState
            }
            : {
                person: "Personne morale",
                entityDetails: initialLegalEntityState
            }

        updateManager(index, newManager);
    };

    const updateManagersValidity = (index: number, isValid: boolean) => {
        listValidity[index] = isValid;
        setManagersValidity(listValidity.every(valid => valid));
        console.log( "managerss validity", listValidity.every(valid => valid) )
    };

    return (
        <>
            <div className="mb-3 row">
                {
                    managers.map((manager, index) =>

                        <div key={index} className="tab-content mb-2">

                            <div className="mb-3 row pt-3">

                                <div className="mb-3 row">
                                    <div className="col-sm-10">
                                        {labelItem ? <h6 className='text-bold'>{`${labelItem} ${index + 1}`}</h6> : ""}
                                    </div>
                                </div>

                                <div className="mb-3 row">

                                    <label htmlFor="personne" className="col-sm-2 col-form-label">Personne</label>

                                    <div className="col-sm-10">
                                        <select
                                            className="form-select"
                                            id="person"
                                            onChange={e => toggleManagerType(
                                                e.target.value as "Personne physique" | "Personne morale",
                                                index
                                            )}
                                            value={manager?.person || ""}
                                        >
                                            {
                                                entityTypes.map(option =>
                                                    <option key={option} value={option}>
                                                        {option}
                                                    </option>
                                                )
                                            }
                                        </select>
                                    </div>

                                </div>
                            </div>

                            {
                                manager.person === "Personne physique"
                                    ?
                                    <IndividualPerson
                                        checked={checked}
                                        onValidationChange={(isValid: boolean) => updateManagersValidity(index, isValid)}
                                        individual={manager.personDetails}
                                        changeIndividual={details => {
                                            const updatedManager: ManagerType = {
                                                ...manager,
                                                personDetails: { ...manager.personDetails, ...details }
                                            };
                                            updateManager(index, updatedManager);
                                        }}
                                    />
                                    :
                                    <LegalEntity
                                        checked={checked}
                                        onValidationChange={(isValid: boolean) => updateManagersValidity(index, isValid)}
                                        societyType={societyTypeOptions}
                                        legalEntity={manager.entityDetails}
                                        changeLegalEntity={details => {
                                            const updatedManager: ManagerType = {
                                                ...manager,
                                                entityDetails: { ...manager.entityDetails, ...details }
                                            };
                                            updateManager(index, updatedManager);
                                        }}
                                    />
                            }
                        </div>
                    )
                }
            </div>

            <div className="row mb-3">
                <div className="col d-flex justify-content-center align-items-center gap-5">
                    <button type='button' onClick={addManager}> {addButtonText} </button>
                    {managers.length > 1 && <button type='button' onClick={removeLastManager}> {removeButtonText} </button>}
                </div>
            </div>
        </>
    );
};